// Copyright (c) 2021 Deere & Company

import { createBrowserHistory } from 'history';

export default createBrowserHistory();
